// Hostnames that serve the public landing page instead of the panel.
export function siteHosts() {
  return (process.env.VELNQO_SITE_HOSTS ?? "velnqo.com,www.velnqo.com")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
}

// Browser origins allowed to submit the landing-page sign-up form.
export function siteOrigins() {
  const schemes = process.env.NODE_ENV === "production" ? ["https"] : ["https", "http"];
  return siteHosts().flatMap((host) => schemes.map((scheme) => `${scheme}://${host}`));
}

export function panelOrigin(): URL | null {
  try {
    const url = new URL(process.env.VELNQO_PUBLIC_URL ?? "");
    return /^https?:$/.test(url.protocol) ? new URL(url.origin) : null;
  } catch {
    return null;
  }
}

export function workspaceBaseDomain() {
  return process.env.VELNQO_WORKSPACE_BASE_DOMAIN?.trim() || "velnqo.com";
}

export function workspacePortalHost() {
  return process.env.VELNQO_WORKSPACE_PORTAL_HOST?.trim().toLowerCase() || "panel.velnqo.com";
}

// callPanelApi reaches the API as the platform panel host, so sign-up requests
// from the landing page run in the same context as the panel itself.
export async function callPanelApi(path: string, init: { method: "GET" | "POST"; body?: string; userAgent?: string | null; clientIP?: string }) {
  const panel = panelOrigin();
  if (!panel) throw new Error("Panel public origin is not configured.");
  const backend = new URL(process.env.VELNQO_API_URL ?? process.env.SKELEE_API_URL ?? "http://45.45.239.4:8082");
  const target = new URL(`${backend.pathname.replace(/\/$/, "")}/api/${path}`, backend.origin);
  const headers = new Headers({ accept: "application/json", host: panel.host });
  if (init.body !== undefined) {
    headers.set("content-type", "application/json");
    headers.set("origin", panel.origin);
  }
  if (init.userAgent) headers.set("user-agent", init.userAgent);
  const proxyToken = process.env.VELNQO_PROXY_TOKEN ?? "";
  if (proxyToken) {
    headers.set("x-velnqo-panel-host", panel.host);
    headers.set("x-velnqo-proxy-key", proxyToken);
    if (init.clientIP) headers.set("x-velnqo-client-ip", init.clientIP);
  }
  return fetch(target, { method: init.method, headers, body: init.body, cache: "no-store", redirect: "manual" });
}
